import { Suspense } from 'react';
import { AppProvider } from '@/app/providers/AppProvider';
import { AppRouter } from '@/app/router';
import { GlobalLoading } from './shared/ui/components/custom/loader/GlobalLoading';

// Global loading fallback


function App() {
  return (
    <Suspense fallback={<GlobalLoading />}>
      <AppProvider>
        <AppRouter />
      </AppProvider>
    </Suspense>
  );
}

export default App;
